export default "__VITE_ASSET__9e3781eb__"